<template>
    <BreadCrumb PageTitle="Ajouter une mandature" />
    <AddMandature />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddMandature from "@/components/Mandatures/AddMandature.vue";
  
    export default defineComponent({
      name: "AddArticlePage",
      components: {
        BreadCrumb,
        AddMandature,
      },
    });
  </script>